import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AgentsLoader from "./agents-loader";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { mapGetters, mapActions } from "vuex";
import { LOAD_AGENTS } from "../store/agent-actions";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AgentsTable",
  components: {
    AgentsLoader,
    ProfileAvatar
  },
  data() {
    return {
      loading: true,
      search: "",
      columns: ["fullName", "clients", "lastLoggedIn", "actions"]
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("AgentStore", ["agents"])), mapGetters("AccountStore", [CURRENT_USER_USERNAME])), {}, {
    filteredAgents() {
      var _context;
      return this.search === "" ? this.agents : _filterInstanceProperty(_context = this.agents).call(_context, ({
        givenName,
        familyName,
        email
      }) => {
        var _context2;
        const stringToEvaluate = `${givenName} ${familyName} ${email}`;
        return _includesInstanceProperty(_context2 = stringToEvaluate.toLowerCase()).call(_context2, this.search.toLowerCase());
      });
    },
    options() {
      return {
        filterable: false,
        sortable: ["fullName", "clients", "lastLoggedIn"],
        columns: ["fullName", "clients", "lastLoggedIn"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        headings: {
          fullName: this.$t("tables.columns.fullName"),
          clients: this.$tc("global.doorr.client", 2),
          lastLoggedIn: this.$t("tables.columns.lastLoginDate"),
          actions: this.$t("global.words.actions")
        },
        columnsClasses: {
          fullname: "w-25"
        },
        skin: "table table-hover",
        perPage: 999999,
        texts: {
          noResults: this.$t("tables.messages.emptyAgents")
        }
      };
    }
  }),
  async mounted() {
    this.loading = true;
    await this.LOAD_AGENTS({
      withClients: true
    });
    this.loading = false;
  },
  destroyed() {
    this.search = "";
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AgentStore", [LOAD_AGENTS])), {}, {
    formatTimeAgo(value) {
      return value ? this.$options.filters.formatTimeAgo(value) : "";
    },
    agentDetailsLink(agent) {
      return {
        name: "agent-details",
        params: {
          agentId: agent.username,
          agent
        }
      };
    }
  })
});